import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const LoadingToRedirect = () => {
  const [count, setCount] = useState(3);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((currentCount) => --currentCount);
    }, 1000);

    if (count === 0) {
      // Pass the current URL as returnUrl so user is redirected back after login
      const returnUrl = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?returnUrl=${returnUrl}`);
    }

    return () => clearInterval(interval);
  }, [count, navigate, location]);
  return (
    <div>
      <p>
        You have been logged out for security purposes. <br />
        Redirecting you in {count} seconds
      </p>
    </div>
  );
};

export default LoadingToRedirect;
